var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReservation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_315_5899",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_5899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2917 3.68056H15.4861V6.45834C15.4861 7.22222 14.8611 7.84722 14.0972 7.84722C13.3334 7.84722 12.7084 7.22222 12.7084 6.45834V3.68056H7.29169V6.45834C7.29169 7.22222 6.66669 7.84722 5.9028 7.84722C5.13891 7.84722 4.51391 7.22222 4.51391 6.45834V3.68056H2.70835C2.1528 3.68056 1.66669 4.16667 1.66669 4.72222V17.2917C1.66669 17.8472 2.1528 18.3333 2.70835 18.3333H17.2917C17.8472 18.3333 18.3334 17.8472 18.3334 17.2917V4.72222C18.3334 4.16667 17.8472 3.68056 17.2917 3.68056ZM16.9445 16.9444H3.05558V10.1389H16.9445V16.9444Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90282 7.15278C6.31949 7.15278 6.59726 6.80556 6.59726 6.45834V2.36112C6.59726 1.94445 6.25004 1.66667 5.90282 1.66667C5.5556 1.66667 5.20837 2.01389 5.20837 2.36112V6.45834C5.20837 6.80556 5.48615 7.15278 5.90282 7.15278Z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0972 7.15278C14.5139 7.15278 14.7917 6.80556 14.7917 6.45834V2.36112C14.7917 1.94445 14.4444 1.66667 14.0972 1.66667C13.75 1.66667 13.4028 2.01389 13.4028 2.36112V6.45834C13.4028 6.80556 13.6805 7.15278 14.0972 7.15278Z",
    fill: "#040000"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_315_5899)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_5899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(1.66669 1.66667)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/reservation.a3ebb92f97518d8451ccb9e33a527632.svg";
export { ForwardRef as ReactComponent };